"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOptions = void 0;
var utils_1 = require("../utils");
var lodash_1 = require("lodash");
var ChartColors_1 = require("../ChartColors");
var getOptions = function (_a) {
    var data = _a.data, size = _a.size, tooltipFormatter = _a.tooltipFormatter;
    return ({
        colors: ChartColors_1.categoricalColorsArray,
        plotOptions: {
            pie: {
                dataLabels: { enabled: false },
                size: size,
            },
        },
        series: [
            {
                data: data,
                type: 'pie',
                innerSize: '50%',
                showInLegend: true,
            },
        ],
        tooltip: __assign(__assign({}, utils_1.tooltipOptions), { useHTML: true, formatter: tooltipFormatter ? tooltipFormatter :
                function () {
                    var _this = this;
                    var dataItem = lodash_1.find(data, function (item) { return lodash_1.get(item, 'name') === _this.key; });
                    return utils_1.ChartTooltipFormatterFn(this.color, this.key, this.y, lodash_1.get(dataItem, 'tooltipBadge'));
                } }),
    });
};
exports.getOptions = getOptions;
